export default {
  namespaced: true,
  state: {
    questions: [],
    loading: false,
    error: null
  },
  mutations: {
    SET_QUESTIONS(state, questions) {
      state.questions = questions
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    // Actions à implémenter
  }
} 